var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginStick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 534,
    height: 904,
    viewBox: "0 0 534 904",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.098 0.5V149.862C387.098 178.168 376.923 205.531 358.429 226.96L292.457 303.4C268.212 331.492 224.672 331.492 200.428 303.4V303.4C176.183 275.308 132.644 275.308 108.399 303.4L0.0937636 428.891",
    stroke: "#FE8700",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.3867 534.298L95.2016 649.594C114.829 668.839 126.989 694.2 129.581 721.298L134.431 772C141.195 842.718 82.5727 902.944 10.2122 899.615L-11.7436 898.605",
    stroke: "#FE8700",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.906 791.908L338.796 791.908C348.989 791.908 359.059 793.177 368.786 796.225C412.875 810.042 540.302 856.326 522.188 924.957",
    stroke: "#FE8700",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginStick);
export default __webpack_public_path__ + "static/media/LoginStick.ea9913026ab35581dc611a9ca13b4b22.svg";
export { ForwardRef as ReactComponent };